/**
 * 仅提供 isMobileDevice，音频输出使用浏览器默认设备
 */

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
}

export function useAudioOutput() {
  return { isMobileDevice };
}
